import './NutriScoreDisplay.css';

const NutriScoreDisplay = ({ score, size = 'normal' }) => {
  const convertScoreToLetter = score => {
    if (!score || typeof score !== 'number') return 'C';

    switch (Math.round(score)) {
      case 5:
        return 'A';
      case 4:
        return 'B';
      case 3:
        return 'C';
      case 2:
        return 'D';
      case 1:
        return 'E';
      default:
        return 'C';
    }
  };

  const selectedLetter = convertScoreToLetter(score);
  const letters = ['A', 'B', 'C', 'D', 'E'];

  return (
    <div className={`nutri-score-scale ${size}`}>
      <div className="nutri-score-header">NUTRI-SCORE</div>
      <div className="nutri-score-letters">
        {letters.map(letter => (
          <div
            key={letter}
            className={`nutri-letter ${letter.toLowerCase()} ${letter === selectedLetter ? 'selected' : ''}`}
            data-letter={letter}
          >
            {letter}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NutriScoreDisplay;
